kimal.products            = {};
kimal.products.menu       = $('#product-menu');
kimal.products.innerList  = $('#product-menu .product-menu__list--inner');
kimal.products.menuItem   = $('#product-menu .product-menu__item');
kimal.products.filter     = $('.product-menu__link');
kimal.products.filterIcon = $('#product-menu__list .plus-btn');

$('#product-menu').on('click', '.plus-btn--tab, .product-menu__link, .product-menu__item--outer', function(event) {
    event.preventDefault();
    event.stopPropagation();

    var $target   = $(event.target),
        funcType  = $target.closest('[data-function-type]').attr('data-function-type');

    if(funcType === 'menu') {
      kimal.products.menu.toggleClass('visible');
      $target.closest('[data-function-type]').toggleClass('minus');
    }

    if(funcType === 'filter') {
      return;
      //ajax request to filter products goes in here
      if($target.hasClass('active')) {
        $target.removeClass('active');
      } else {
        kimal.products.filter.removeClass('active');
        $target.addClass('active');
      }
    }

    if(funcType === 'accordion') {
      var li             = $target.closest('[data-function-type="accordion"]'),
          plusBtn        = li.find('.plus-btn'),
          innerList      = li.children('.product-menu__list--inner'),
          innerListItems = innerList.children('.product-menu__item--inner'),
          height         = 0;

      if(!li.hasClass('active')) {
        kimal.products.filterIcon.removeClass('minus');
        plusBtn.addClass('minus');

        innerListItems.each(function(){
          var item = $(this);
          height += parseInt(item.outerHeight());
        });

        innerList.css({
            'height': 6 + 'em'
        });

        kimal.products.menuItem.removeClass('active');
        li.addClass('active');

      } else {
        plusBtn.removeClass('minus');
        li.removeClass('active');

        innerList.css({
            'height': 0 + 'em'
        });
      }
    }
});

$('body').on('click', function(e) {
  var $productMenu = $('#product-menu');

  if (!$productMenu.hasClass('visible')) return;

  var $productMenuTab = $productMenu.find('.product-menu__tab');

  if (!$(e.target).is('#' + $productMenu.attr('id'))) {
    kimal.products.menu.toggleClass('visible');
    $productMenuTab.find('.minus').toggleClass('minus');
  }
});

$('#reset-filters').on('click', function(e) {
    e.preventDefault();
    kimal.products.filter.removeClass('active');
    kimal.products.filterIcon.removeClass('minus');
});
